import React from "react";
import { MoreHorizontal } from "lucide-react";

const CompetitorTable = ({ competitors }) => {
  return (
    <div className="competitor-table">
      <table className="table table-hover mb-0">
        <thead>
          <tr>
            <th>Competitor</th>
            <th>Traffic</th>
            <th>Product</th>
            <th>Sales</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {competitors.map((competitor) => (
            <tr key={competitor.domain} className="competitor-row">
              <td>
                <div className="d-flex align-items-center gap-2">
                  <img
                    src={competitor.icon}
                    alt={competitor.name}
                    width="24"
                    height="24"
                  />
                  {competitor.domain}
                </div>
              </td>
              <td>{competitor.traffic}</td>
              <td>{competitor.product}</td>
              <td>{competitor.sales}</td>
              <td>
                <button className="btn btn-sm btn-light">
                  <MoreHorizontal size={16} />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default CompetitorTable;
